// extracted by mini-css-extract-plugin
export var deleteIcon = "_tf-5";
export var deleteOption = "_tf-3";
export var divider = "_tf-2";
export var downloadIcon = "_tf-4";
export var drawer = "_tf-0";
export var drawerFooter = "_tf-6";
export var drawerOpen = "_tf-1";
export var highlighted = "_tf-7";
export var lighterHighlight = "_tf-8";